module.exports = __webpack_public_path__ + "img/certificationPicUrl.920da1fa.png";